import { useState } from "react";

export const useDisableCopyPaste = () => {
  const [pressedCtrl, setPressedCtrl] = useState(false);

  const onKeyPressDisablePaste = (e: KeyboardEvent) => {
    console.log(e.key);
    if (["Control", "MetaRight", "MetaLeft"].includes(e.key)) {
      setPressedCtrl(true);
    }

    if (e.key === "v") {
      if (pressedCtrl) {
        e.preventDefault();
      }
    }
  };
  const onKeyUpDisablePaste = (e: KeyboardEvent) => {
    if (["Control", "MetaRight", "MetaLeft"].includes(e.key)) {
      setPressedCtrl(false);
    }
  };

  return { onKeyPressDisablePaste, onKeyUpDisablePaste };
};
